import { Formik } from 'formik';
import Select from 'react-select';
import { Col, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { useEffect, useState } from 'react';
import { formSelectDefault, getSelectErrorBorder } from '../../Components/constants/styles';
import { generateAssmtValidationSchema } from './utils';
import { APIClient } from '../../helpers/ApiHeleps';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

const GenerateAssessmentComp = ({ onCloseClick, show, formSubmit }) => {
    const api = new APIClient();
    const [assessmentList, setAssessmentList] = useState([]);
    const userCredential = useSelector((state) => state.CommonStore.loginToken);
    const [loading, setLoading] = useState(false);
    const [samApiToken, setSamApiToken] = useState();
    const history = useHistory();

    useEffect(() => {
        if (!userCredential?.token && !userCredential?.apiKey) {
            history.replace('/login');
        } else if (userCredential?.token && userCredential?.apiKey) {
            setSamApiToken({ ...userCredential });
            fetchAssmtApi({ ...userCredential });
        }
    }, []);

    const fetchAssmtApi = async (apiToken) => {
        try {
            setLoading(true);
            let resp = await api.get('all', apiToken);
            if (resp?.status === 200 && resp?.data?.isSuccess) {
                setAssessmentList(resp?.data?.data?.length ? resp?.data?.data : []);
                setLoading(false);
            } else if (!resp?.data?.isSuccess) {
                toast.error('Something went wrong while fetching assesments.');
                setAssessmentList([]);
                setLoading(false);
            }
        } catch (error) {
            toast.error('Something went wrong try again.');
            setLoading(false);
        }
    };

    const prepareOptions = (assmtList) => {
        return assmtList?.map((item) => {
            return { ...item, label: `${item?.name} (version-${item?.version})` };
        });
    };
    return (
        <>
            <Modal isOpen={show} toggle={onCloseClick} centered={true} size="lg">
                <ModalHeader className="bg-soft-primary">Add Assessment</ModalHeader>
                <ModalBody className="py-3 px-5">
                    <Formik
                        initialValues={{ assessment: '' }}
                        validationSchema={generateAssmtValidationSchema}
                        onSubmit={(values) => {
                            formSubmit(values);
                        }}
                    >
                        {({ setFieldValue, values, errors, handleSubmit, touched, handleBlur }) => (
                            <>
                                <Row>
                                    <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="d-flex mb-4">
                                        <Label className="col-form-label w-40">
                                            Assessment Name
                                            <span className="text-danger">*</span>
                                        </Label>
                                        <Select
                                            name="assessment"
                                            id="assessment"
                                            value={values?.assessment}
                                            components={{ IndicatorSeparator: () => null }}
                                            className="w-60"
                                            placeholder="Select"
                                            onChange={(e) => setFieldValue('assessment', e)}
                                            getOptionLabel={(e) => e.label}
                                            getOptionValue={(e) => e.internalIdentifier}
                                            isLoading={loading}
                                            styles={{
                                                ...formSelectDefault,
                                                ...getSelectErrorBorder(!!errors.assessment && touched.assessment)
                                            }}
                                            options={assessmentList?.length ? prepareOptions(assessmentList) : []}
                                        />
                                    </Col>

                                    <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="d-flex justify-content-end">
                                        <div>
                                            <button
                                                type="button"
                                                className="btn btn-md btn-primary waves-effect center waves-light me-3"
                                                onClick={handleSubmit}
                                                disabled={loading}
                                            >
                                                {loading ? 'Loading...' : 'Generate Assesment'}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-md btn-outline-primary"
                                                id="gapsCancel"
                                                onClick={onCloseClick}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </>
                        )}
                    </Formik>
                </ModalBody>
            </Modal>
        </>
    );
};

export default GenerateAssessmentComp;
